import React from 'react'

export default function Tudu({ tudu, toggleTudu }) {

    const tuduClickHandler = () => {

        toggleTudu(tudu.id)

    };

    return (

    <div className="tudu">

        <label className="container">

            <input type="checkbox" className="tudu--checkbox" checked={ tudu.completed } onChange={ tuduClickHandler } />
            <span class="checkmark"></span>
            <div className="tudu--text">{ tudu.name }</div>

        </label>

    </div>

    )

};
